<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>CONTENTS</h1>
<p class="tocfm" id="racknow"><a class="xref" href="#/chiAkerman0007#acknow">Acknowledgments</a></p>
<p class="tocf" id="rintro"><a class="xref" href="#/chiAkerman0008#intro">INTRODUCTION</a></p>
<p class="tocau">JAMES R. AKERMAN</p>
<p class="toc" id="rch01"><a class="xref" href="#/chiAkerman0009#ch01">CHAPTER ONE</a></p>
<p class="toc1">Cartography and Decolonization</p>
<p class="tocau">RAYMOND B. CRAIB</p>
<p class="toc" id="rch02"><a class="xref" href="#/chiAkerman0010#ch02">CHAPTER TWO</a></p>
<p class="toc1">Entangled Spaces: Mapping Multiple Identities in Eighteenth-Century New Spain</p>
<p class="tocau">MAGALI CARRERA</p>
<p class="toc" id="rch03"><a class="xref" href="#/chiAkerman0011#ch03">CHAPTER THREE</a></p>
<p class="toc1">Cartography in the Production (and Silencing) of Colombian Independence History, 1807–1827</p>
<p class="tocau">LINA DEL CASTILLO</p>
<p class="toc" id="rch04"><a class="xref" href="#/chiAkerman0012#ch04">CHAPTER FOUR</a></p>
<p class="toc1">Democratizing the Map: The Geo-body and National Cartography in Guatemala, 1821–2010</p>
<p class="tocau">JORDANA DYM</p>
<p class="toc" id="rch05"><a class="xref" href="#/chiAkerman0013#ch05">CHAPTER FIVE</a></p>
<p class="toc1">Uncovering the Roles of African Surveyors and Draftsmen in Mapping the Gold Coast, 1874–1957</p>
<p class="tocau">JAMIE MCGOWAN</p>
<p class="toc" id="rch06"><a class="xref" href="#/chiAkerman0014#ch06"><span class="page" id="pvi"></span>CHAPTER SIX</a></p>
<p class="toc1">Multiscalar Nations: Cartography and Countercartography of the Egyptian Nation-State</p>
<p class="tocau">KAREN CULCASI</p>
<p class="toc" id="rch07"><a class="xref" href="#/chiAkerman0015#ch07">CHAPTER SEVEN</a></p>
<p class="toc1">Art on the Line: Cartography and Creativity in a Divided World</p>
<p class="tocau">SUMATHI RAMASWAMY</p>
<p class="toc" id="rch08"><a class="xref" href="#/chiAkerman0016#ch08">CHAPTER EIGHT</a></p>
<p class="toc1">Signs of the Times: Commercial Road Mapping and National Identity in South Africa</p>
<p class="tocau">THOMAS J. BASSETT</p>
<p class="tocbmf" id="rcontrib"><a class="xref" href="#/chiAkerman0017#contrib">Contributors</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/chiAkerman0018#index">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Akerman-0006.vue?d31505a2